/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Contactconsent1Inputs */

const en__field_contactconsent1 = /** @type {(inputs: _Field_Contactconsent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I agree that ICS-RM may contact me`)
};

const de__field_contactconsent1 = /** @type {(inputs: _Field_Contactconsent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich bin einverstanden, dass der ICS-RM mich kontaktiert`)
};

/**
* | output |
* | --- |
* | "I agree that ICS-RM may contact me" |
*
* @param {_Field_Contactconsent1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_contactconsent1 = /** @type {((inputs?: _Field_Contactconsent1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Contactconsent1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_contactconsent1(inputs)
	return de__field_contactconsent1(inputs)
});
export { _field_contactconsent1 as "_field_contactConsent" }